var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FeatureFlagActionType } from './types';
export default function featureFlagReducer(state, action) {
    switch (action.type) {
        case FeatureFlagActionType.payLater: {
            return __assign(__assign({}, state), { payLater: action.payload });
        }
        case FeatureFlagActionType.showMarketingSettings: {
            return __assign(__assign({}, state), { showMarketingSettings: action.payload });
        }
        case FeatureFlagActionType.showPrivacySettings: {
            return __assign(__assign({}, state), { showPrivacySettings: action.payload });
        }
        default: {
            return state;
        }
    }
}
